// extracted by mini-css-extract-plugin
export default {"content":"mainRoute_content__qUbLH"};